/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlContactTypeAssignment = {
    ConfiguredByClientRole: 'configured_by_client_role',
    Broker: 'broker',
    Retailbroker: 'retailbroker'
} as const;
export type ControlContactTypeAssignment = typeof ControlContactTypeAssignment[keyof typeof ControlContactTypeAssignment];


export function ControlContactTypeAssignmentFromJSON(json: any): ControlContactTypeAssignment {
    return ControlContactTypeAssignmentFromJSONTyped(json, false);
}

export function ControlContactTypeAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlContactTypeAssignment {
    return json as ControlContactTypeAssignment;
}

export function ControlContactTypeAssignmentToJSON(value?: ControlContactTypeAssignment | null): any {
    return value as any;
}

